import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import StringListFilterPipe from '../../directives/string-list-filter.pipe';

@Component({
    selector: 'mapp-select-checkeable',
    templateUrl: './select-checkeable.component.html',
    styleUrls: ['./select-checkeable.component.scss'],
    providers: [StringListFilterPipe],
    standalone: false,
})
export class SelectCheckeableComponent implements OnChanges {
    @Input() label: string;

    @Input() placeholder = 'Select one or more options';

    @Input() options = [];

    @Input() disabled: boolean;

    @Output() change = new EventEmitter();

    isOpen = false;

    filterValue = '';

    selectedOptions = [];

    /**
     *
     * @param pipe
     */
    constructor(private readonly pipe: StringListFilterPipe) {}

    /**
     *
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.options?.currentValue && this.selectedOptions?.length) {
            this.selectedOptions = [];
        }
    }

    /**
     *
     */
    close() {
        this.isOpen = false;
    }

    /**
     *
     */
    toggleAll(): void {
        const options = this.pipe.transform(this.options, this.filterValue);

        if (this.selectedOptions.length === options.length) {
            this.selectedOptions = [];
        } else {
            this.selectedOptions = [...options];
        }

        this.change.emit(this.selectedOptions);
    }

    /**
     *
     * @param optionValue
     */
    toggle(optionValue: string): void {
        if (this.selectedOptions.includes(optionValue)) {
            this.selectedOptions.splice(
                this.selectedOptions.findIndex((item) => item === optionValue),
                1
            );
        } else {
            this.selectedOptions.push(optionValue);
        }

        this.change.emit(this.selectedOptions);
    }

    /**
     *
     */
    getDisplayText(): string {
        const selectedCount = this.selectedOptions?.length || 0;

        if (selectedCount === 0) {
            return this.placeholder;
        }

        const placeholderElement = document.querySelector(
            '.select-checkeable__placeholder'
        ) as HTMLElement;

        if (!placeholderElement) {
            return this.placeholder;
        }

        const maxWidth = placeholderElement.offsetWidth - 50;

        if (this.isOpen) {
            const fullText = this.selectedOptions.join(', ');
            return this.fitsWithinContainer(fullText, maxWidth)
                ? fullText
                : this.truncateText(fullText, maxWidth);
        }

        let visibleText = '';
        let remainingCount = 0;

        for (let i = 0; i < this.selectedOptions.length; i++) {
            const option = this.selectedOptions[i];
            const testText = visibleText ? `${visibleText}, ${option}` : option;

            const testWithEllipsis = `${testText}, ... +${selectedCount - i - 1}`;

            if (this.fitsWithinContainer(testWithEllipsis, maxWidth)) {
                visibleText = testText;
            } else {
                remainingCount = selectedCount - i;
                break;
            }
        }

        const resultText =
            remainingCount > 0 ? `${visibleText}, ... +${remainingCount}` : visibleText;

        return resultText;
    }

    /**
     *
     * @param text
     * @param maxWidth
     * @param extra
     */
    private truncateText(text: string, maxWidth: number, extra?: string): string {
        const placeholderElement = document.querySelector(
            '.select-checkeable__placeholder'
        ) as HTMLElement;
        if (!placeholderElement) {
            return text;
        }
        const testElement = document.createElement('span');
        testElement.style.visibility = 'hidden';
        testElement.style.position = 'absolute';
        testElement.style.whiteSpace = 'nowrap';
        placeholderElement.appendChild(testElement);

        const ellipsis = '...';
        const extraText = extra ? ` ${ellipsis} ${extra}` : ellipsis;
        let truncatedText = text;

        while (truncatedText.length > 0) {
            testElement.textContent = truncatedText + extraText;
            if (testElement.offsetWidth <= maxWidth) {
                break;
            }
            const newLength = Math.floor(truncatedText.length * 0.8);
            truncatedText = truncatedText.slice(0, newLength);
        }

        placeholderElement.removeChild(testElement);
        return truncatedText + extraText;
    }

    /**
     *
     * @param text
     * @param maxWidth
     */
    private fitsWithinContainer(text: string, maxWidth: number): boolean {
        const placeholderElement = document.querySelector(
            '.select-checkeable__placeholder'
        ) as HTMLElement;
        if (!placeholderElement) {
            return true;
        }

        const testElement = document.createElement('span');
        testElement.style.visibility = 'hidden';
        testElement.style.position = 'absolute';
        testElement.style.whiteSpace = 'nowrap';
        testElement.textContent = text;

        placeholderElement.appendChild(testElement);
        const fits = testElement.offsetWidth <= maxWidth;
        placeholderElement.removeChild(testElement);

        return fits;
    }

    /**
     *
     */
    clearFilter() {
        this.filterValue = '';
    }
}
